var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  "aria-label": "pro icon",
  viewBox: "0 0 34 18"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 33,
  height: 17,
  x: 0.5,
  y: 0.5,
  fill: "#182534",
  rx: 8.5
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 17,
  y: 12.6,
  fill: "#FFF",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: -0.2,
  textAnchor: "middle"
}, "PRO")));
export default SvgProBadge;